import React from "react";
import { Formik, Form, Field } from "formik";
import { Button, Card } from "react-bootstrap";
import { injectIntl, FormattedMessage } from "react-intl";
import Alert from "react-s-alert";
import { contactAdd } from "../../../redux/actions";
import { Input } from "../../../formik";

const ContactForm = ({ intl, email }) => {
  const submitContact = (values) => {
    contactAdd(values)
      .then((resp) => {
        Alert.success(intl.formatMessage({ id: resp.message }));
      })
      .catch((err) => Alert.error(intl.formatMessage({ id: err.message })));
  };
  return (
    <Formik
      onSubmit={(values) => submitContact(values)}
      initialValues={{
        name: "",
        email,
        message: "",
      }}
      enableReinitialize={true}
    >
      {({ values }) => {
        return (
          <Form className="add-event-form">
            <Card className="h-100 s-card">
              <Card.Header>
                {intl.formatMessage({
                  id: `link.contact`,
                })}
              </Card.Header>
              <Card.Body>
                <Field
                  component={Input}
                  type="text"
                  placeholder={intl.formatMessage({
                    id: "input.contact.name",
                  })}
                  name="name"
                />
                <Field
                  component={Input}
                  type="email"
                  placeholder={intl.formatMessage({
                    id: "input.contact.email",
                  })}
                  name="email"
                  required
                  disabled
                />
                <Field
                  component={Input}
                  type="text"
                  as="textarea"
                  rows={3}
                  placeholder={intl.formatMessage({
                    id: "input.contact.message",
                  })}
                  name="message"
                  required
                />
                <Button className="btn-custom" type="submit"><FormattedMessage id="button.submit" /></Button>
              </Card.Body>
              <Card.Footer>
                <div className="download-container d-flex">
                  <div className="orange-bg text-center support">
                    <a
                      href={`${process.env.REACT_APP_WP_SITE_ROOT}/telechargement-e-slides/`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-download" />
                    </a>
                  </div>
                  <div className="support-text">
                    <p className="font-common-13 uc">
                      <FormattedMessage id="link.download" />
                    </p>
                    <span className="droid-serif">
                      <a
                        href={`${process.env.REACT_APP_WP_SITE_ROOT}/telechargement-e-slides/`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FormattedMessage id="link.room-software" />
                      </a>
                    </span>
                  </div>
                </div>
                <div className="support-container d-flex m-t-20">
                  <div className="orange-bg text-center support">
                    <span>
                      <i className="fas fa-envelope"></i>
                    </span>
                  </div>
                  <div className="support-text">
                    <p className="font-common-13 uc">
                      <FormattedMessage id="link.support" />
                    </p>
                    <a
                      href="mailto:support@e-slides.net"
                      className="droid-serif"
                    >
                      support@e-slides.net
                    </a>
                  </div>
                </div>
              </Card.Footer>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
};

export default injectIntl(ContactForm);
